import { Control as ControlType } from '@yleisradio/areena-types';
import { Control as ControlComponent } from 'components/Controls/Control';
import React from 'react';
import { MediaType, Region } from 'services/areena-api/types';
import { getControlKey } from 'utils/control';
import {
  GeoRestrictionNotification,
  useGeoRestrictionState,
} from './GeoRestrictionNotification/GeoRestrictionNotification';
import styles from './HeaderPlayControls.module.scss';

type Props = {
  playControl: ControlType;
  programMediaType: MediaType | undefined;
  programRegion: Region | undefined;
  queueControl: ControlType | undefined;
};

export const HeaderPlayControls: React.FC<Props> = ({
  playControl,
  programMediaType,
  programRegion,
  queueControl,
}) => {
  const isProgramGeoBlocked =
    useGeoRestrictionState(programRegion) !== 'no-restriction';

  return (
    <div className={styles.root}>
      <div className={styles.buttons}>
        <div className={styles.playControl}>
          <ControlComponent
            control={playControl}
            controlKey={getControlKey(playControl)}
            as="button"
            size="sm"
            variant="primary"
            width="full"
            dataTestId="play-control"
            disabled={isProgramGeoBlocked}
          />
        </div>
        {queueControl ? (
          <div className={styles.queueControl}>
            <ControlComponent
              control={queueControl}
              controlKey={getControlKey(queueControl)}
              as="button"
              size="sm"
              variant="secondary"
              dataTestId="queue-control"
            />
          </div>
        ) : null}
      </div>
      {isProgramGeoBlocked && (
        <div className={styles.geoRestrictionNotification}>
          <GeoRestrictionNotification
            programMediaType={programMediaType}
            programRegion={programRegion}
          />
        </div>
      )}
    </div>
  );
};
